import TeamMenu from "../../components/teamMenu/TeamMenu";
import TableTeams from "../../components/tableTeams/TableTeams";

const TeamsPage = () => (
  <TeamMenu>
    <TableTeams />
  </TeamMenu>
);

export default TeamsPage;
